module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("Search: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-scrollable"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key.id
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(key.title) + " "), _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key.id] > 0 ? 'asc' : 'dsc'
    })])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedData), function(entry) {
    return _c('tr', _vm._l((_vm.columns), function(key) {
      return _c('td', [(key.id === 'actions') ? [(entry[key.id] === true) ? [_c('action-buttons', {
        attrs: {
          "element": entry,
          "mail-action": _vm.mailAction,
          "edit-action": _vm.editAction,
          "delete-action": _vm.deleteAction
        }
      })] : [_vm._v("\n\t\t\t\t\t\t\t\t---\n\t\t\t\t\t\t\t")]] : (key.id === 'status' || key.id === 'deviceType') ? [_c('span', {
        domProps: {
          "innerHTML": _vm._s(entry[key.id])
        }
      })] : [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("booleanToString")(_vm._f("arrayToString")(entry[key.id]))) + "\n\t\t\t\t\t\t")]], 2)
    }))
  }))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        _vm.movePages(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v("\n\t\t Page "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.gotoPage),
      expression: "gotoPage",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.totalPages
    },
    domProps: {
      "value": (_vm.gotoPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gotoPage = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" of " + _vm._s(_vm.totalPages) + " \n\t\t"), _c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        _vm.movePages(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f08ac4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/TableGrid.vue
// module id = 608
// module chunks = 1